import {InjectionToken} from "@angular/core";

export interface ApiModuleConfig {
  apiUrl?: string;
}

export const API_MODULE_CONFIG = new InjectionToken('ApiModuleConfig');
